import { http } from "../client";
var isResetPasswordFailure = function (error) {
    var _a, _b;
    return (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors;
};
export var resetPassword = function (_a) {
    var email = _a.email, password = _a.password, token = _a.token;
    return http.base
        .post("/reset-password", {
        password: password,
        token: token,
        email: email,
        password_confirmation: password,
    })
        .then(function () { return ({ type: "success" }); })
        .catch(function (error) {
        if (isResetPasswordFailure(error)) {
            return { type: "failure", errors: error.response.data.errors };
        }
        return Promise.reject(error);
    });
};
